import { render } from "./HelloWorld.vue?vue&type=template&id=7ae37253&scoped=true"
import script from "./HelloWorld.vue?vue&type=script&lang=ts"
export * from "./HelloWorld.vue?vue&type=script&lang=ts"

import "./HelloWorld.vue?vue&type=style&index=0&id=7ae37253&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-7ae37253"

export default script